/*
 *
 * UserEditPage actions
 *
 */

import {
  DEFAULT_ACTION,
  GET_USER_ACTION,
  CHANGE_PASSWORD_ACTION,
  CHANGE_USER_ACTION,
  CHANGE_PASSWORD_SUCCESS_ACTION,
  LANGUAGE_ACTION,
  GET_PRACTICE_MESSAGES,
  GET_PRACTICE_MESSAGES_SUCCESS,
  GET_PRACTICE_MESSAGES_ERROR,
  CHANGE_PASS_RESET,
} from "./constants";

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function getUserAction() {
  return {
    type: GET_USER_ACTION,
  };
}

export function getLanguageAction() {
  return {
    type: LANGUAGE_ACTION,
  };
}

export function changePasswordSuccess() {
  return { type: CHANGE_PASSWORD_SUCCESS_ACTION };
}

export function changePassword(oldPassword, newPassword, callback) {
  return {
    type: CHANGE_PASSWORD_ACTION,
    oldPassword,
    newPassword,
    callback,
  };
}

export function changeUser(userData, callback) {
  return {
    type: CHANGE_USER_ACTION,
    userData,
    callback,
  };
}

export function getPracticeMessages({ limit, offset, filter }) {
  return {
    type: GET_PRACTICE_MESSAGES,
    limit,
    offset,
    filter,
  };
}
export function getPracticeMessagesSuccess({ messages }) {
  return {
    type: GET_PRACTICE_MESSAGES_SUCCESS,
    messages,
  };
}
export function getPracticeMessagesError({ error }) {
  return {
    type: GET_PRACTICE_MESSAGES_ERROR,
    error,
  };
}

export function resetPassMessage() {
  return {
    type: CHANGE_PASS_RESET,
  };
}
